import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "basePageWraper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "hero is-link" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hero-body" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "title has-text-left" }, " 패스워드 찾기 결과 "),
    /*#__PURE__*/_createElementVNode("p", { class: "subtitle has-text-left" }, " 회원님의 이메일로 변경 메일을 발송하였습니다. ")
  ])
], -1)
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle has-text-center" }, " 회원님의 이메일로 변경 메일을 발송하였습니다. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle has-text-center" }, " 메일의 링크를 통해 비밀번호를 변경 할 수 있습니다. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
        class: "button is-link"
      }, "홈으로 이동")
    ])
  ]))
}